export const formatHoney = (honeyAmount: number, decimals: number = 2): string => {
  return Number(honeyAmount).toFixed(decimals);
};